export enum CountryRouteName {
    Index = 'system.countries.index',
    Create = 'system.countries.create',
    Edit = 'system.countries.edit',
}

export default {
    path: 'countries',
    name: CountryRouteName.Index,
    component: () => import('@/views/system/country/Index.vue'),
    meta: {
        auth: true,
        label: 'Countries',
        icon: 'fal fa-flag fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-countries',
    },
    children: [
        {
            path: 'create',
            name: CountryRouteName.Create,
            component: () => import('@/views/system/country/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Country',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-countries',
            },
        },
        {
            path: ':countryId/edit',
            name: CountryRouteName.Edit,
            component: () => import('@/views/system/country/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Country',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-countries',
            },
        },
    ],
}
